import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Container } from '../components/Container';
const companies = [{
  name: 'Gridiron Insurance',
  logo: 'https://i.imgur.com/jbXIGC2.png'
}, {
  name: 'Coaction Specialty Insurance',
  logo: 'https://i.imgur.com/1upH9sL.png'
}, {
  name: 'SBLI',
  logo: 'https://i.imgur.com/E5D7zSR.png'
}];
export function TrustedBy() {
  return <section className="border-y border-white/[0.06] py-10 sm:py-12" data-id="element-953">
      <Container data-id="element-954">
        <motion.div initial={{
        opacity: 0,
        y: 8
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '400px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-8" data-id="element-955">
          <div className="text-xl font-semibold tracking-tight text-zinc-300 sm:text-2xl" data-id="element-956">
            Trusted by
          </div>
          <ul className="grid w-full max-w-4xl grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-957">
            {companies.map((c, i) => <motion.li key={c.name} initial={{
            opacity: 0,
            scale: 0.96
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '400px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="flex aspect-[16/9] items-center justify-center rounded-xl border border-white/10 bg-white p-4 shadow-sm sm:p-5" title={c.name} data-id="element-958">
                <img src={c.logo} alt={c.name} className="max-h-10 w-auto max-w-[85%] object-contain sm:max-h-12" data-id="element-959" />
              </motion.li>)}
            <motion.li initial={{
            opacity: 0,
            scale: 0.96
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '400px'
          }} transition={{
            duration: 0.4,
            delay: 0.15
          }} className="relative flex aspect-[16/9] items-center justify-center overflow-hidden rounded-xl border border-sky-300/50 bg-gradient-to-br from-blue-600 via-sky-400 to-cyan-300 p-4 text-center shadow-lg shadow-sky-500/20 sm:p-5" data-id="element-960">
              <span className="text-sm font-bold tracking-tight text-white drop-shadow sm:text-base" data-id="element-961">
                + and more
              </span>
            </motion.li>
          </ul>
        </motion.div>
      </Container>
    </section>;
}